import {Box,Typography} from '@mui/material';
import './css/styles.css';

import logo1 from '../../assets/Imagenes/Ayuda/Logo1.png'

const CarruselClasificacion = ({Imagen,Titulo,Style}) =>{
    return (
        <Box id={Style}>
            <Box>
                <Typography className='TituloTarjeta' variant='h3'>{Titulo}</Typography>
                <Box className='ContenedorImagen'>
                    <img src={Imagen} />
                </Box>
                
            </Box>
        </Box>
    );
}


export default CarruselClasificacion;


CarruselClasificacion.defaultProps = {
 Titulo:'Set funerario',
 Style:'TarjetaCalificacion',
 Imagen:logo1
};